import { render, staticRenderFns } from "./MftLogo.vue?vue&type=template&id=e5deaf5a&"
import script from "./MftLogo.vue?vue&type=script&lang=js&"
export * from "./MftLogo.vue?vue&type=script&lang=js&"
import style0 from "./MftLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports